import React from 'react';

export default function CMButton({
  label,
  icon,
  onClick,
  className = '',
  type = 'button',
}) {
  return (
    <button
      type={type}
      className={`text-white bg-accent baseText flex items-center gap-2 px-4 py-2 rounded-md whitespace-nowrap ${className}`}
      onClick={onClick}
    >
      {icon}
      {label}
    </button>
  );
}
